import { getApiClient } from './authApiClient';

// ==================== PLANS & PACKAGING ====================

// Canonical feature/limit definitions the admin UI renders from.
export const getPlansSchema = async () => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get('/plans/schema');
  return response.data; // { success, data: { features:[], limits:[] } }
};

// List plans. Admins may pass includeInactive to see hidden plans.
export const getPlans = async ({ includeInactive = false } = {}) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get('/plans', { params: includeInactive ? { includeInactive: true } : {} });
  return response.data; // { success, data: [...], stripeEnabled }
};

export const getPlan = async (key) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get(`/plans/${encodeURIComponent(key)}`);
  return response.data;
};

export const createPlan = async (plan) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post('/plans', plan);
  return response.data;
};

export const updatePlan = async (key, plan) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.put(`/plans/${encodeURIComponent(key)}`, plan);
  return response.data;
};

export const deletePlan = async (key) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.delete(`/plans/${encodeURIComponent(key)}`);
  return response.data;
};

export const reorderPlans = async (items) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post('/plans/reorder', { items });
  return response.data;
};

// Seed the four default tiers into an empty catalog.
export const seedDefaultPlans = async (force = false) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post('/plans/seed-defaults', { force });
  return response.data;
};

// ==================== SUBSCRIPTION / CHECKOUT ====================

// Current subscription mirror for a tenant.
export const getSubscription = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get(`/billing/subscription/${encodeURIComponent(tenantId)}`);
  return response.data; // { success, data }
};

// Derived entitlements for a tenant.
export const getEntitlements = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get(`/billing/entitlements/${encodeURIComponent(tenantId)}`);
  return response.data; // { success, data }
};

// Start a Stripe Checkout session (returns { url } when Stripe is enabled).
export const startCheckout = async ({ planKey, interval = 'month', tenantId, successUrl, cancelUrl }) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post('/billing/checkout/session', {
    planKey, interval, tenantId,
    successUrl: successUrl || window.location.href,
    cancelUrl: cancelUrl || window.location.href,
  });
  return response.data;
};

// Open the Stripe Customer Portal (returns { url } when Stripe is enabled).
export const openBillingPortal = async ({ tenantId, returnUrl } = {}) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post('/billing/portal/session', { tenantId, returnUrl: returnUrl || window.location.href });
  return response.data;
};

export default {
  getPlansSchema, getPlans, getPlan, createPlan, updatePlan, deletePlan, reorderPlans, seedDefaultPlans,
  getSubscription, getEntitlements, startCheckout, openBillingPortal,
};
